export const brandCards = [
  {
    id: "light",
    name: "Light poster",
    use: "Matches the Pound Town and No Problemo cards. Recommended for Featured Brands.",
    src: "https://cdn.magicpatterns.com/patterns/generated-images/5fd9f23c-6ce3-4a0b-82ea-4ea88f89f296.jpg",
  },
  {
    id: "dark",
    name: "Dark poster",
    use: "Moodier alternative. Good for social posts or a Krushers collection banner.",
    src: "https://cdn.magicpatterns.com/patterns/generated-images/730ddd37-ad09-4658-964b-a3253c6bef21.jpg",
  },
];
